<div class="animate__animated animate__fadeInRight">
    <br />
  
    <div class="col">
      <mat-card class="mat_card_general">
        <h1 class>Modulo de Nacionalidad</h1>
      </mat-card>
    </div>
  
    <br />
    <mat-card class="mat-elevation-z5 mat_card_general_content">
      <app-agregar-nacionalidades
        (onDebounce)="actualizarTabla($event)"
      ></app-agregar-nacionalidades>
      <br />
      <app-lista-nacionalidades
        (onDebounce)="actualizarTabla($event)"
        [nacionalidades_List]="nacionalidad"
      ></app-lista-nacionalidades>
    </mat-card>
    <hr />
  </div>
  